import { assign } from 'lodash';
import { rounds, config } from '../api';
import types from './mutationTypes';

export default {
  loadResults({ commit }, payload) {
    return rounds.getRounds(payload.wheel, assign(payload, {
      translations: 'RouletteWeb',
    })).then((results) => {
      commit(types.SET_RESULTS, results);
      return results;
    });
  },
  setConfig({ commit }, name) {
    commit(types.SET_CONFIG, config.getConfig(name));
  },
};
